import { WhiteLabelService } from '../../services/white-label.service';

/** Aplica titulo/favicon del dominio dedicado antes del primer render de Angular. */
export function initHostPreLoginWhiteLabel(whiteLabelService: WhiteLabelService): () => Promise<void> {
  return () => {
    whiteLabelService.applyPreLoginForCurrentHost();
    return Promise.resolve();
  };
}
